/* eslint-disable eqeqeq */
import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { Text } from './Text';
import { useWindowScrollYIsGreaterThanEqual } from '../utils';

const useStyle = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    padding: '20px',
    [theme.breakpoints.down('lg')]: {
      padding: '10px 15%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px 20px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '10px 20%',
    },
  },
  text: {
    margin: 'auto 20%',
    lineHeight: 1.45,
    [theme.breakpoints.down('sm')]: {
      margin: 'auto 10%',
      padding: '10px',
    },
    [theme.breakpoints.down('xs')]: {
      margin: 'auto 5%',
      padding: '10px',
      lineHeight: 1.25,
    },
    [theme.breakpoints.up('lg')]: {
      margin: 'auto 5%',
      padding: '10px',
    },
  },
  bg: {
    background: theme.palette.lightGrey,
  },
  paddingTop: {
    paddingTop: ({ isGreaterThanEqual }) => (isGreaterThanEqual ? 227 : 0),
    [theme.breakpoints.down('md')]: {
      paddingTop: ({ isGreaterThanEqual }) => (isGreaterThanEqual ? 100 : 0),
    },
    // [theme.breakpoints.down('md')]: {
    //   paddingTop: 150,
    // },
  },
}));

const COLORS = [
  ['#a3b253', '#959f6b'],
  ['#d7b34e', '#bda367'],
  ['#73a0bb', '#6f90a6'],
  ['#94bedc', '#8facc1'],
  ['#5b888d', '#57747b'],
  ['#a9575f', '#8c5b61'],
  ['#ddc65b', '#b5a44c'],
  ['#be97bb', '#a0788b'],
  ['#646093', '#5d4f78'],
  ['#80a08f', '#718b7a'],
  ['#d2d673', '#afb273'],
  ['#6274b5', '#626fa1'],
];

function randomNumber() {
  return Math.floor(Math.random() * (12 - 1)) + 1;
}

const Wrapper = ({ background, title, content }) => {
  const styles = useStyle();
  return (
    <Box className={styles.root} style={{ backgroundColor: background }}>
      <Text
        variant="h2"
        className={styles.text}
        style={{ letterSpacing: 'normal' }}
      >
        <Trans>{title}</Trans>
      </Text>
      <Text
        variant="h3"
        className={styles.text}
        style={{ fontFamily: 'SofiaProLight', fontWeight: 'bold' }}
      >
        <Trans>{content}</Trans>
      </Text>
    </Box>
  );
};

export const SwitchColor = () => {
  const windowGlobal = typeof window !== 'undefined' && window;
  const isGreaterThanEqual = useWindowScrollYIsGreaterThanEqual(150);
  const styles = useStyle({ isGreaterThanEqual });
  const [key, setKey] = React.useState(undefined);
  const [light, dark] = COLORS[key ?? 0];

  React.useLayoutEffect(() => {
    setKey(windowGlobal.localStorage.getItem('random-color'));
  }, [windowGlobal]);

  React.useLayoutEffect(() => {
    const random = randomNumber();
    windowGlobal.localStorage.setItem('random-color', random);
  }, [windowGlobal]);

  return (
    <Box component="div" className={`${styles.bg} ${styles.paddingTop}`}>
      <Wrapper background={light} title="titleIT" content="introIT" />
      <Wrapper background={dark} title="titleEN" content="introEN" />
    </Box>
  );
};

Wrapper.propTypes = {
  background: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
